import '~/javascript/jquery'

import * as ActiveStorage from "@rails/activestorage"
import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'

import 'arrive'
import 'bootstrap'
import '@mux/mux-player'

ActiveStorage.start()
Rails.start()
Turbolinks.start()

// stimulus support
import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'
const application = Application.start()

// const controllers = import.meta.glob('~/**/*_controller.js', { eager: true })
const controllers = import.meta.glob([
  './controllers/ace_controller.js', // used
  // './controllers/datatables_controller.js', //not used, want jQuery
  // './controllers/flatkid_controller.js',  //not used
  // './controllers/flatkids_controller.js', //not used
  // './controllers/flatpickr_controller.js', //not used
  './controllers/glightbox_controller.js',
  // './controllers/range_controller.js', //not used
  '~/**/reveal_all_controller.js',
  '~/**/reveal_controller.js',
  '~/**/player_management_controller.js',
  // './controllers/sherlock_controller.js', //not used, wants jQuery
  // './controllers/tabulator_controller.js', //not used, empty
], { eager: true })

registerControllers(application, controllers)

// controllers from yarn packages - imports
import ContentLoader from "stimulus-content-loader"
import Clipboard from "stimulus-clipboard"
import NestedForm from "stimulus-rails-nested-form"
application.register("content-loader", ContentLoader)
application.register("clipboard", Clipboard)
application.register("nested-form", NestedForm)

import './website_custom'
